import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import {
  retrieveAfterClosing,
  retrieveClosing,
  retrieveExecution,
  retrieveRecentTrades,
  retrieveStockData,
  retrieveStockDividend,
  retrieveStockInfo,
  retrieveStockOpening,
  retrieveStockSession,
} from "../../Services/StockSessionApiService";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import $ from "jquery";
import { Tooltip } from "bootstrap";
import { Avatar } from "primereact/avatar";
import DividendDialog from "../../Components/PrimeReact/Dividend/dialog";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { useAuthHeader } from "../../auth/AuthService";
import { DateTimer } from "../../Components/Timer/dateTimer";

function CurrentStock() {
  const { t, i18n } = useTranslation();
  const [cookies, setCookie] = useCookies(["icode", "bType", "currency"]);

  var START = 1;
  var IN_PROGRESS = 2;
  var MARKET_CLOSING = 99;
  const [STATE, setSTATE] = useState(START);
  const authHeader = useAuthHeader();

  const boards = [
    { name: t("Main Board"), value: "M" },
    { name: t("Growth Board"), value: "G" },
  ];
  const currencies = [
    { name: t("KHR"), value: "KHR" },
    { name: t("USD"), value: "USD" },
  ];
  const [icodes, setIcodes] = useState([]);

  const [issue, setIssue] = useState({});
  const [stock, setStock] = useState({});
  const [dividend, setDividend] = useState({});

  const [board, setBoard] = useState("M");
  const [currency, setCurrency] = useState("KHR");
  const [icode, setIcode] = useState("");

  //PRICE INFORMATION
  const [currentP, setCurrnentP] = useState("");
  const [peRatio, setPeRatio] = useState("");
  const [baseP, setBaseP] = useState("");
  const [upperPLimit, setUpperPLimit] = useState("");
  const [lowerPLimit, setLowerPLimit] = useState("");
  const [openingP, setOpeningP] = useState("");
  const [highP, setHighP] = useState("");
  const [lowP, setLowP] = useState("");

  //TRADE INFORMATION
  const [tTime, setTTime] = useState("");
  const [tradeP, setTradeP] = useState("");
  const [change, setChange] = useState("");
  const [changePer, setChangePer] = useState("");
  const [accVol, setAccVol] = useState("");
  const [accVal, setAccVal] = useState("");
  const [mkCap, setMkCap] = useState("");
  const [fmkCap, setFmkCap] = useState("");

  //BEST ORDER
  const [ord, setOrd] = useState({});
  const [epP, setEpP] = useState("");
  const [epQty, setEpQty] = useState("");

  //LAST 5 TRADE
  const [trd, setTrd] = useState([]);

  // INITIALIZE
  async function init() {
    !cookies.bType && setCookie("bType", "M");
    !cookies.currency && setCookie("currency", "KHR");
    setBoard(cookies.bType);
    setCurrency(cookies.currency);

    await retrieveStockInfo(cookies.bType, null, authHeader())
      .then((response) => {
        let data = response.data.data;
        if (data) {
          // CHECK ICODE FROM COOKIE
          let icode = cookies.icode;
          if (!icode || !data.issues.map((v) => v.icode).includes(icode)) {
            icode = board == "G" ? "KH1000150008" : "KH1000100003";
            setCookie("icode", icode);
          }
          setIcode(icode);
          let icodes = data.issues
            .sort(function (a, b) {
              if (a.esymbol < b.esymbol) return -1;
              if (a.esymbol > b.esymbol) return 1;
              return 0;
            })
            .map((v) => ({ name: v.esymbol, value: v.icode }));
          setIcodes(icodes);
        }
      })
      .catch((error) => console.log(error));
  }

  // ISSUE INFORMATION
  async function updateStockInfo() {
    board &&
      icode &&
      (await retrieveStockInfo(board, icode, authHeader())
        .then((response) => {
          let issueData = response.data.data.issue;
          let stockData = response.data.data.stock;
          setStock(response.data.data.stock);
          setIssue(issueData);
          setBaseP(issueData.bprice);
          setCurrnentP(issueData.bprice);
          setUpperPLimit(issueData.hlprice);
          setLowerPLimit(issueData.llprice);
          setPeRatio(issueData.pe);

          retrieveStockDividend(board, icode, authHeader())
            .then((response) => {
              let v = response.data.data;
              let diviSign = 1;
              let txtdiv = "";
              if (v.divi == 1) {
                txtdiv = (
                  <img src="/img/d-sign.png" className="vertical-align-super" />
                );
                diviSign = 1;
              }

              if (v.xd == 1) {
                txtdiv = (
                  <img
                    src="/img/xd-sign.png"
                    className="vertical-align-super"
                  />
                );
                diviSign = 2;
              }

              let divi = {
                stock: stockData.isymbol,
                lp: stockData.ilp,
                diviSign: diviSign,
                txtdiv: txtdiv,
                type_of_dividend: v?.dividend?.itypeDividend,
                dividend_per_share: v?.dividend?.idividendPerShare,
                ex_dividend_date: v?.dividend?.iexDividendDate,
                record_date: v?.dividend?.irecodeDate,
                payment_date: v?.dividend?.ipaymentDate,
                link: v?.dividend?.iwebsiteLink,
              };
              setDividend(divi);
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error)));
  }

  // OPENING
  async function updateOpeningPrice() {
    await retrieveStockOpening(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        if (data.open) {
          setSTATE(IN_PROGRESS);
        }
      })
      .catch((error) => console.log(error));
  }

  // BEST ORDER DATA
  async function updateData() {
    board &&
      icode &&
      (await retrieveStockData(board, icode, currency, authHeader())
        .then((response) => {
          let data = response.data.data;
          if (data) {
            setOrd(data);
            setEpP(data.etprice);
            setEpQty(data.etquantity);
          } else {
            setOrd(null);
            setEpP("");
            setEpQty("");
          }

          switch (STATE) {
            case START:
              updateOpeningPrice();
              updateExecutionData();
              break;
            case IN_PROGRESS:
              updateExecutionData();
              break;
            case MARKET_CLOSING:
              updateAfterClosing();
              break;
            default:
          }

          check();
        })
        .catch((error) => console.log(error)));
  }

  // EXECUTION DATA
  async function updateExecutionData() {
    await retrieveExecution(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        let exTime = data?.ttime;
        if (exTime) {
          setTTime(
            exTime?.substr(0, 2) +
              ":" +
              exTime?.substr(2, 2) +
              ":" +
              exTime?.substr(4, 2)
          );
        } else {
          setTTime("-");
        }
        setTradeP(data.tprice);
        setChange(data.cpday);
        setChangePer(
          data.cpday && ((data.cpday / issue.bprice) * 100).toFixed(2)
        );
        setAccVol(data.ctquantity);
        setAccVal(data.ctamount);
        setMkCap(data.mrkCap);
        setFmkCap(data.fullMrkCap);
        setOpeningP(data.oprice);
        data.tprice && setCurrnentP(data.tprice);
        data.hprice && setHighP(data.hprice);
        data.lprice && setLowP(data.lprice);
        data.pe && setPeRatio(data.pe);
      })
      .catch((error) => console.log(error));

    updateRecentTrades();
  }

  //CLOSING
  async function updateClosing() {
    await retrieveClosing(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        data.icprice && setCurrnentP(data.icprice);
        data.pe && setPeRatio(data.pe);
        setSTATE(MARKET_CLOSING);
      })
      .catch((error) => console.log(error));
  }

  async function check() {
    await retrieveStockSession(authHeader())
      .then((response) => {
        response.data.data.session && updateClosing();
      })
      .catch((error) => console.log(error));
  }

  async function updateAfterClosing() {
    await retrieveAfterClosing(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        if (data?.mscode == MARKET_CLOSING) {
          setOrd(data);
          setEpP(data.etprice);
          setEpQty(data.etquantity);
        }
        $("#open").removeClass("text-red text-green");

        if (
          (accVol === 0 && baseP == currentP) ||
          (accVol === 0 && baseP != currentP)
        ) {
          setOpeningP("-");
          setHighP(currentP);
          setLowP(currentP);
        } else {
          $("#high").removeClass("text-red text-green");
          $("#low").removeClass("text-red text-green");
        }
      })
      .catch((error) => console.log(error));
  }

  async function updateRecentTrades() {
    await retrieveRecentTrades(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        while (data.length < 5) {
          data.push({
            cpday: "",
            tprice: "",
            tquantity: "",
            ttime: "",
            value: "",
          });
        }
        setTrd(data);
      })
      .catch((error) => console.log(error));
  }

  const onChangeBoard = (e) => {
    let val = e.value;
    setBoard(val);
    setSTATE(START);
    setCookie("bType", val);
    if (val == "G") {
      setIcode("KH1000150008");
    } else {
      setIcode("KH1000100003");
    }
  };

  const onChangeStock = (e) => {
    let val = e.value;
    setIcode(val);
    setSTATE(START);
    setCookie("icode", val);
  };

  const onChangeCurrency = (e) => {
    let val = e.value;
    setCurrency(val);
    setSTATE(START);
    setCookie("currency", val);
  };

  useEffect(() => {
    updateData();
    updateStockInfo();
    if (trd.length == 0) {
      let data = [];
      for (let i = 0; i < 5; i++) {
        data.push({
          cpday: "",
          tprice: "",
          tquantity: "",
          ttime: "",
          value: "",
        });
      }
      setTrd(data);
    }

    var intervalOrd = setInterval(updateData, 5000);
    if (
      STATE == MARKET_CLOSING ||
      new Date().setHours(15, 10, 0) < new Date().getTime()
    ) {
      clearInterval(intervalOrd);
    }
    return () => {
      clearInterval(intervalOrd);
    };
  }, [icode, currency, STATE, i18n.language]);

  useEffect(() => {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl, {
        animation: true,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner py-2"></div></div>',
      });
    });

    init();
  }, [board]);

  const timeBodyTemplate = (rowData) => {
    let time = rowData.ttime
      ? rowData.ttime.substr(0, 2) + ":" + rowData.ttime.substr(2, 2)
      : "";
    return (
      <div className="flex justify-content-center">
        <span className="flex text-sm">{time}</span>
      </div>
    );
  };

  const lpriceBodyTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <span className="flex text-sm">
          {rowData?.tprice
            ? rowData?.tprice?.toLocaleString("en-US")
            : rowData?.tprice === 0
            ? "-"
            : ""}
        </span>
      </div>
    );
  };

  const cpdayBodyTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <span className="flex align-items-center text-sm">
          <UpDownSign
            comparePrice={rowData.cpday}
            tradeP={rowData.tprice}
            issue={issue}
          />
          &nbsp;
          {rowData.cpday && Math.abs(rowData.cpday)}
        </span>
      </div>
    );
  };

  const cperBodyTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <span className="flex text-sm">
          {rowData.cpday != 0
            ? ((rowData.cpday / baseP) * 100).toFixed(2)
            : rowData.cpday === 0
            ? "0"
            : ""}
        </span>
      </div>
    );
  };

  const volBodyTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <span className="flex text-sm">
          {rowData?.tquantity
            ? rowData?.tquantity?.toLocaleString("en-US")
            : rowData?.tquantity === 0
            ? "-"
            : ""}
        </span>
      </div>
    );
  };

  const valBodyTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <span className=" flex text-sm">
          {rowData?.value
            ? rowData?.value?.toLocaleString("en-US")
            : rowData?.value === 0
            ? "-"
            : ""}
        </span>
      </div>
    );
  };

  const icodeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <Avatar
          image={`/img/issue_logo_icons/${option?.value}_logo.jpg`}
          shape="circle"
        />
        &nbsp;&nbsp;<div>{option.name}</div>
      </div>
    );
  };

  const selectedIcodeTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <Avatar
            image={`/img/issue_logo_icons/${option?.value}_logo.jpg`}
            shape="circle"
            className="absolute"
          />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const selectedBoardTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  return (
    <>
      <LogoHeader />

      <div className="col-12 -mt-3">
        <div className="grid">
          {/* Price Information & Trade Information */}
          <div className="col-12 md:col-4 md:pr-2">
            <div className="card px-3 py-4 shadow-3 border-round-lg bg-card">
              <div className="grid">
                <div className="col-12 line-height-1 pb-0">
                  <div className="flex justify-content-between align-items-center pb-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">
                      <DateTimer type={1} />
                    </span>
                    <span className="text-sm">
                      <DateTimer type={2} />
                    </span>
                  </div>
                  <div className="flex justify-content-start align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className=" font-bold text-yellow-500">
                      {t("Price Information")}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Current Price")}</span>
                    <span
                      className={
                        (currentP > baseP
                          ? "text-green"
                          : currentP < baseP && !!currentP
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {currentP ? currentP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("P/E Ratio")}</span>
                    <span className="text-sm">
                      {peRatio
                        ? peRatio.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Base Price/IPO Price")}</span>
                    <span className="text-sm">
                      {baseP ? baseP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Upper Price Limit")}</span>
                    <span
                      className={
                        (upperPLimit > baseP
                          ? "text-green"
                          : upperPLimit < baseP && !!upperPLimit
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {upperPLimit ? upperPLimit.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Lower Price Limit")}</span>
                    <span
                      className={
                        (lowerPLimit > baseP
                          ? "text-green"
                          : lowerPLimit < baseP && !!lowerPLimit
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {lowerPLimit ? lowerPLimit.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Opening Price")}</span>
                    <span
                      className={
                        (openingP > baseP
                          ? "text-green"
                          : openingP < baseP && !!openingP
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {openingP ? openingP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("High Price")}</span>
                    <span
                      className={
                        (highP > baseP
                          ? "text-green"
                          : highP < baseP && !!highP
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {highP ? highP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Low Price")}</span>
                    <span
                      className={
                        (lowP > baseP
                          ? "text-green"
                          : lowP < baseP && !!lowP
                          ? "text-red"
                          : "") + " text-sm"
                      }
                    >
                      {lowP ? lowP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-start align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className=" font-bold text-yellow-500">
                      {t("Trade Information")}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Time")}</span>
                    <span className="text-sm">{tTime}</span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Trade Price")}</span>
                    <span className="text-sm">
                      {tradeP ? tradeP.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Change")}</span>
                    <span className="text-sm">
                      &nbsp;
                      <UpDownSign
                        comparePrice={change}
                        tradeP={tradeP}
                        issue={issue}
                      />
                      &nbsp;
                      {change ? Math.abs(change).toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("%Change")}</span>
                    <span className="text-sm">
                      {changePer ? changePer.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Acc. Volume")}</span>
                    <span className="text-sm">
                      {accVol ? accVol.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">{t("Acc. Value (KHR)")}</span>
                    <span className="text-sm">
                      {accVal ? accVal.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">
                      {t("Market Cap. (Mil. KHR)")}
                    </span>
                    <span className="text-sm">
                      {mkCap
                        ? mkCap.toLocaleString("en-US", {
                            maximumFractionDigits: 0,
                          })
                        : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-between align-items-center py-2 px-1 border-bottom-1 border-blue-700">
                    <span className="text-sm">
                      {t("Full Market Cap. (M. KHR)")}
                    </span>
                    <span className="text-sm">
                      {fmkCap
                        ? fmkCap.toLocaleString("en-US", {
                            maximumFractionDigits: 0,
                          })
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 md:col-8 md:pl-4">
            {/* Filter */}
            <div
              className="card p-3 shadow-3 border-round-lg border-1 mb-5"
              style={{
                backgroundImage:
                  "linear-gradient(0deg, rgba(232,76,4,1) 0%, rgba(232,128,80,1) 100%)",
              }}
            >
              <div className="grid align-items-center pt-2">
                <div className="col-4 py-0 border-right-2">
                  <Dropdown
                    value={board}
                    onChange={onChangeBoard}
                    options={boards}
                    valueTemplate={selectedBoardTemplate}
                    optionLabel="name"
                    placeholder="Select a Board"
                    className="w-full border-round-lg"
                  />
                </div>
                <div className="col-4 py-0 border-right-2">
                  <Dropdown
                    value={icode}
                    onChange={onChangeStock}
                    options={icodes}
                    valueTemplate={selectedIcodeTemplate}
                    itemTemplate={icodeOptionTemplate}
                    optionLabel="name"
                    placeholder="Select a Stock"
                    className="w-full border-round-lg"
                  />
                </div>
                <div className="col-4 py-0">
                  <Dropdown
                    value={currency}
                    onChange={onChangeCurrency}
                    options={currencies}
                    optionLabel="name"
                    placeholder="Select a Currency"
                    className="w-full border-round-lg"
                  />
                </div>
                <div className="col-12 flex justify-content-center pb-0 font-bold">
                  {stock &&
                    (i18n.language == "kh" ? stock.iname : stock.inameEnglish)}
                  &nbsp;
                  <DividendDialog issue={dividend}></DividendDialog>
                </div>
              </div>
            </div>

            {/* Current Quotations & Remaining Quantity of Orders */}
            <div className="card p-4 pb-2 shadow-3 border-round-lg bg-card">
              <div className="grid">
                <div className="col-12">
                  <div className="flex justify-content-around align-items-center pb-4 px-2 border-bottom-1 border-blue-700">
                    <span className="md:text-xl text-sm font-bold">
                      {t("Expected Price")} : &nbsp;&nbsp;
                      {epP ? epP.toLocaleString("en-US") : "-"}
                    </span>
                    <span className="border-right-2">&nbsp;</span>
                    <span className="md:text-xl text-sm font-bold">
                      {t("Expected Quantity")} : &nbsp;&nbsp;
                      {epQty ? epQty.toLocaleString("en-US") : "-"}
                    </span>
                  </div>
                  <div className="flex justify-content-center py-3 px-2">
                    <span className="md:text-2xl text-lg font-bold text-yellow-500">
                      {t("Current Quotations & Remaining Quantity of Orders")}
                    </span>
                  </div>
                  <div className="p-2">
                    <div className="flex grid">
                      <div className="col-4 text-sm md:text-xl border-y-1 border-left-1 border-blue-700">
                        <div className="flex justify-content-center font-bold">
                          {t("Sell Remaining Quantity")}
                        </div>
                      </div>
                      <div className="col-4 text-sm md:text-xl border-1 border-blue-700">
                        <div className="flex justify-content-center font-bold">
                          {t("Price")}
                        </div>
                      </div>
                      <div className="col-4 text-sm md:text-xl border-y-1 border-right-1 border-blue-700">
                        <div className="flex justify-content-center font-bold">
                          {t("Buy Remaining Quantity")}
                        </div>
                      </div>

                      {/* Sell Remaining Quantity */}
                      <div className="col-4 text-sm line-height-3-4 border-left-1 border-blue-700">
                        <div className="flex justify-content-end">
                          {ord?.fifthSSRQPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-end">
                          {ord?.fthSSRQPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-end">
                          {ord?.tssrqpqprice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-end">
                          {ord?.sssrqpqprice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-end">
                          {ord?.fssrqpqprice?.toLocaleString("en-US")}
                        </div>
                      </div>

                      {/* Price */}
                      <div className="col-4 text-sm border-x-1 border-blue-700 line-height-3-4">
                        <div
                          className={
                            (ord?.fifthSSPQPrice > baseP
                              ? "text-green"
                              : ord?.fifthSSPQPrice < baseP &&
                                !!ord?.fifthSSPQPrice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fifthSSPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.fthSSPQPrice > baseP
                              ? "text-green"
                              : ord?.fthSSPQPrice < baseP && !!ord?.fthSSPQPrice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fthSSPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.tsspqprice > baseP
                              ? "text-green"
                              : ord?.tsspqprice < baseP && !!ord?.tsspqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.tsspqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.ssspqprice > baseP
                              ? "text-green"
                              : ord?.ssspqprice < baseP && !!ord?.ssspqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.ssspqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.fsspqprice > baseP
                              ? "text-green"
                              : ord?.fsspqprice < baseP && !!ord?.fsspqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fsspqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.fsbpqprice > baseP
                              ? "text-green"
                              : ord?.fsbpqprice < baseP && !!ord?.fsbpqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fsbpqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.ssbpqprice > baseP
                              ? "text-green"
                              : ord?.ssbpqprice < baseP && !!ord?.ssbpqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.ssbpqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.tsbpqprice > baseP
                              ? "text-green"
                              : ord?.tsbpqprice < baseP && !!ord?.tsbpqprice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.tsbpqprice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.fthSBPQPrice > baseP
                              ? "text-green"
                              : ord?.fthSBPQPrice < baseP && !!ord?.fthSBPQPrice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fthSBPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div
                          className={
                            (ord?.fifthSBPQPrice > baseP
                              ? "text-green"
                              : ord?.fifthSBPQPrice < baseP &&
                                !!ord?.fifthSBPQPrice
                              ? "text-red"
                              : "") + " flex justify-content-center"
                          }
                        >
                          {ord?.fifthSBPQPrice?.toLocaleString("en-US")}
                        </div>
                      </div>

                      {/* Buy Remaining Quantity */}
                      <div className="col-4 text-sm line-height-3-4 border-right-1 border-blue-700">
                        <div className="flex justify-content-start">&nbsp;</div>
                        <div className="flex justify-content-start">&nbsp;</div>
                        <div className="flex justify-content-start">&nbsp;</div>
                        <div className="flex justify-content-start">&nbsp;</div>
                        <div className="flex justify-content-start">&nbsp;</div>
                        <div className="flex justify-content-start">
                          &nbsp;
                          {ord?.fsbrqpqprice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-start">
                          &nbsp;
                          {ord?.ssbrqpqprice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-start">
                          &nbsp;
                          {ord?.tsbrqpqprice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-start">
                          &nbsp;
                          {ord?.fthSBRQPQPrice?.toLocaleString("en-US")}
                        </div>
                        <div className="flex justify-content-start">
                          &nbsp;
                          {ord?.fifthSBRQPQPrice?.toLocaleString("en-US")}
                        </div>
                      </div>

                      <div className="col-4 text-sm md:text-xl border-y-1 border-left-1 border-blue-700">
                        <div className="flex justify-content-end">
                          {ord?.surqquote?.toLocaleString("en-US")}
                        </div>
                      </div>
                      <div className="col-4 text-sm md:text-xl border-1 border-blue-700">
                        <div className="flex justify-content-center font-bold">
                          {t("Total")}
                        </div>
                      </div>
                      <div className="col-4 text-sm md:text-xl border-y-1 border-blue-700 border-right-1">
                        <div className="flex justify-content-start">
                          {ord?.burqquote?.toLocaleString("en-US")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Last 5 Trades */}
      <div className="col-12">
        <div className="text-2xl pl-2 pb-1 font-bold">{t("Last 5 trades")}</div>
        <div className="card px-4 py-3 shadow-3 border-round-lg bg-card">
          <DataTable
            value={trd}
            tableStyle={{ minWidth: "50rem" }}
            className="text-white"
            tableClassName="bg-none"
          >
            <Column
              field="ttime"
              align="center"
              header={t("Time")}
              body={timeBodyTemplate}
              className="border-blue-700 text-white p-0"
              headerClassName="p-0 pb-2"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
            <Column
              field="tprice"
              align="center"
              header={t("Execution Price")}
              body={lpriceBodyTemplate}
              className="border-blue-700 text-white p-0 pb-2"
              headerClassName="p-0"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
            <Column
              field="cpday"
              align="center"
              header={t("Change")}
              body={cpdayBodyTemplate}
              className="border-blue-700 text-white"
              headerClassName="p-0 pb-2"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
            <Column
              field="cpday"
              align="center"
              header={t("%Change")}
              body={cperBodyTemplate}
              className="border-blue-700 text-white"
              headerClassName="p-0 pb-2"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
            <Column
              field="tquantity"
              align="center"
              header={t("Trading Volume")}
              body={volBodyTemplate}
              className="border-blue-700 text-white"
              headerClassName="p-0 pb-2"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
            <Column
              field="value"
              align="center"
              header={t("Trading Value (KHR)")}
              body={valBodyTemplate}
              className="border-blue-700 text-white"
              headerClassName="p-0 pb-2"
              bodyClassName="p-0 py-1"
              style={{ background: "none" }}
            ></Column>
          </DataTable>
        </div>
      </div>
    </>
  );
}

export default CurrentStock;

function UpDownSign({ comparePrice, tradeP, issue }) {
  let img = "";
  if (issue) {
    if (comparePrice > 0) {
      if (tradeP == issue.hlprice) {
        img = <img className="up-down-arrow" src="/img/upper_sign.png" />;
      } else {
        img = <img className="up-down-arrow" src="/img/up_sign.png" />;
      }
    } else if (comparePrice < 0) {
      if (tradeP == issue.llprice) {
        img = <img className="up-down-arrow" src="/img/lower_sign.png" />;
      } else {
        img = <img className="up-down-arrow" src="/img/low_sign.png" />;
      }
    }
  }

  return <>{img}</>;
}
